import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export function ArrowBackIcon(props) {
  return <ArrowBackIosIcon {...props} />;
}
export function ArrowForwardIcon(props) {
  return <ArrowForwardIosIcon {...props} />;
}
export function ArrowRightIcon(props) {
  return <KeyboardArrowRightIcon {...props} />;
}
export function ArrowLeftIcon(props) {
  return <KeyboardArrowLeftIcon {...props} />;
}
export function DropdownIcon(props) {
  return <ArrowDropDownIcon color="primary" {...props} />;
}
